import { JSX as IonicJSX } from '@ionic/core';
import { IonRadio } from '@ionic/react';
import { PropsWithChildren } from 'react';

import styles from '@/components/Radio/index.module.css';

type IonRadioProps = IonicJSX.IonRadio;

type RadioProps = Omit<IonRadioProps, 'justify'>;

export const Radio = ({ children, ...props }: PropsWithChildren<RadioProps>) => {
  return (
    <IonRadio {...props} alignment='center' className={styles.radio} justify='start' labelPlacement='end'>
      {children}
    </IonRadio>
  );
};
